import isMobile from '@lib/utils/isMobile';
import { LG1 } from '@lib/assets/styles/breakpoints';
import useWindowDimensions from '@lib/hooks/useWindowDimensions';

// User-agent sniffing alone is defeated by browser "Desktop site" mode, which
// swaps the UA string without actually widening the physical viewport. Fall
// back to viewport width so small screens are still treated as mobile.
export default function useIsMobileDevice() {
  const { width } = useWindowDimensions();
  const { phone, tablet } = isMobile();

  return phone || tablet || width <= LG1;
}
